import DecisionEnum from '../enums/DecisionEnum'
import dayjs from 'dayjs'
import { Option } from '../../../components/Form/Inputs/AutocompleteInput'

export type RecruitmentFormValues = {
  id: string
  candidateId: string
  completionDate: dayjs.Dayjs | undefined
  completionTime: dayjs.Dayjs | undefined
  responsibles?: Option[]
  step: string
  stage: string
  decision: DecisionEnum | undefined
  comments: string
  version: number
}

export const defaultRecruitmentFormValues: RecruitmentFormValues = {
  id: '',
  candidateId: '',
  completionDate: dayjs(),
  completionTime: dayjs(),
  responsibles: [],
  step: '',
  stage: '',
  decision: DecisionEnum.WAITING,
  comments: '',
  version: 1,
}